
export function padToFour(number) {
  if (number <= 9999) {
    number = (`${number }000`).slice(-4)
  }
  return number
}

export function getUrlVars() {
  const vars = {}
  let hash
  const windowHref = window.location.href
  const queryStringBeginingIndex = windowHref.indexOf('?')
  if (queryStringBeginingIndex === -1) {
    return undefined
  }
  const hashes = windowHref.slice(queryStringBeginingIndex + 1).split('&')
  for (let i = 0; i < hashes.length; i = i + 1) {
    hash = hashes[i].split('=')
    const key = decodeURIComponent(hash[0])
    const value = decodeURIComponent(hash[1])
    vars[key] = value
  }

  return vars
}



// WEBPACK FOOTER //
// ./src/common/common.js